
import { defineComponent, onMounted } from 'vue';
import { formateNum } from '@/common/utils';

export default defineComponent({
  props: {
    // 点赞数
    likeCount: {
      type: Number,
      default: () => 0,
    },
    // 评论数
    commentCount: {
      type: Number,
      default: () => 0,
    },
    // 分享数
    forwardCount: {
      type: Number,
      default: () => 0,
    },
    photoId: {
      type: Number,
      default: () => 0,
    },
    authorId: {
      type: Number,
      default: () => 0,
    },
    liked: {
      type: Number,
      default: () => 0,
    }
  },
  setup(props, ctx) {
    const handleClick = (type: string) => {
      ctx.emit('actionClick', {
        type,
      });
    };

    onMounted(() => {

    })
    return {
      handleClick,
      formateNum,
    };
  },
});
